export default __webpack_public_path__ + "media/music/8de63c8c4756f6f7e194a1134d9a0ad0.mp3";